(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["expert-video"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const cssHref = 'https://cdn.jsdelivr.net/npm/@fancyapps/ui@5.0/dist/fancybox/fancybox.css';
    const jsSrc = 'https://cdn.jsdelivr.net/npm/@fancyapps/ui@5.0/dist/fancybox/fancybox.umd.js';

    // Load CSS once
    if (!document.querySelector(`link[href="${cssHref}"]`)) {
      const link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = cssHref;
      document.head.appendChild(link);
    }

    // Load JS once
    if (!window.Fancybox) {
      const script = document.createElement('script');
      script.src = jsSrc;
      script.onload = initFancy;
      document.head.appendChild(script);
    } else {
      initFancy();
    }

    function initFancy() {
      Fancybox.bind('[data-fancybox="hero-video"]', {
        Hash: false,
        Thumbs: false,
        Toolbar: { display: { left: [], middle: [], right: ['close'] } },
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-footer"] && !Shopify.designMode) return;
  try {
    
  function isValidEmail(email) {
    const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return emailPattern.test(email);
  }

  document.addEventListener('DOMContentLoaded', function () {
    var form = document.getElementById('subscribe-form');
    var thankYouMessage = document.getElementById('thank-you-message');
    var error = document.getElementById('error-subscribe');

    var isSubmitting = false;

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (isSubmitting) return;

      var email = document.getElementById('email-id').value;
      var submitBtn = form.querySelector('.submit-btn');

      error.style.display = 'none';

      if (!isValidEmail(email)) {
        error.textContent = 'Enter valid email';
        error.style.display = 'block';
        return;
      }

      isSubmitting = true;
      submitBtn.disabled = true;

      var formData = new FormData(form);
      if (window.UTMHandler && window.UTMHandler.appendUTMsToFormData) {
        window.UTMHandler.appendUTMsToFormData(formData);
      }
      fetch('/contact', {
        method: 'POST',
        body: formData,
        headers: {
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
      })
        .then(function (response) {
          if (response.status === 429) throw new Error('too_many_requests');
          if (response.ok) {
            form.style.display = 'none';
            thankYouMessage.style.display = 'block';
            sessionStorage.setItem('formSubmitted', 'true');
          } else {
            throw new Error('server_error');
          }
        })
        .catch(function (err) {
          error.textContent = err.message === 'too_many_requests'
            ? 'Too many requests. Please wait a moment and try again.'
            : 'Something went wrong. Please try again.';
          error.style.display = 'block';
        })
        .finally(function () {
          isSubmitting = false;
          submitBtn.disabled = false;
        });
    });
  });

  const emailInputs = document.querySelectorAll('.email-id');

  emailInputs.forEach((inputElement) => {
    inputElement.addEventListener('beforeinput', (event) => {
      const text = event.target.value;
      const maxLength = 50;
      const selection = window.getSelection().toString();
      const inputType = event.inputType;

      // Prevent input if it exceeds the 10-character limit
      if (text.length >= maxLength && inputType !== 'deleteContentBackward' && selection === '') {
        event.preventDefault();
      }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
